import MigrationDTO from '@src/adapters/dto/migration/MigrationDTO';
import useApi, { ApiOptions } from '../base/useApi';
import MigrationFilterDTO from '@src/adapters/dto/migration/MigrationFilterDTO';

interface Params {
  filter: MigrationFilterDTO;
}

interface Result {
  migrations: MigrationDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/migrations/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindMigrations = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindMigrationsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindMigrations;
